module.exports = __webpack_public_path__ + "img/aParty_111523_I.0e568e2f.jpg";